/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Map_CampusInputs */

const en_map_campus = /** @type {(inputs: Map_CampusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Campus`)
};

const fr_map_campus = /** @type {(inputs: Map_CampusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Campus`)
};

const ms_sg2_map_campus = /** @type {(inputs: Map_CampusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kampus`)
};

/**
* | output |
* | --- |
* | "Campus" |
*
* @param {Map_CampusInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const map_campus = /** @type {((inputs?: Map_CampusInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Map_CampusInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_map_campus(inputs)
	if (locale === "fr") return fr_map_campus(inputs)
	return ms_sg2_map_campus(inputs)
});